import { usePWAInstall } from '../../../hooks/usePWAInstall';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { Route, Routes } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { FormAuthV2 } from '../forms/FormAuthV2';
import { FormNewPassword } from '../forms/FormNewPassword';
import { FormRecoverPassword } from '../forms/FormRecoverPassword';

export const LayoutLogin = () => {
    const [authData] = useDataAuth();
    const { checkingSession } = authData;
    const { isInstallable, handleInstallClick } = usePWAInstall();

    return (
        <Grid
            container
            sx={{
                boxSizing: 'border-box',
                display: 'flex',
                flexFlow: 'wrap',
                width: '100%',
                minHeight: '100vh',
                position: 'relative',
                alignItems: 'center',
                justifyContent: 'center',
                px: { xs: 2, sm: 0 },
            }}
        >
            {checkingSession ? (
                <Grid size={{ xs: 12 }} display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress />
                </Grid>
            ) : (
                <>
                    <Grid size={{ xs: 0, md: 1 }} />
                    <Grid size={{ xs: 0, sm: 5, md: 5, lg: 5 }}
                        display={{ xs: 'none', sm: 'flex' }}
                        alignItems="center"
                        justifyContent="flex-end"
                        sx={{ pr: '10vw', height: '100%' }}
                    >
                        {/* <img src={logoImage} alt="imagen" width='230' height='230' /> */}
                    </Grid>

                    <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{ pl: '6vw', height: '100%' }}
                    >
                        <Paper
                            elevation={4}
                            sx={{
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                                minHeight: '40vh',
                                width: '100%',
                                borderRadius: 4,
                                opacity: 0.9,
                                px: 3,
                                py: 5,
                            }}
                        >
                            <Routes>
                                <Route
                                    path="/"
                                    element={<FormAuthV2 authData={authData} />}
                                />
                                <Route
                                    path="/newPassword"
                                    element={<FormNewPassword authData={authData} />}
                                />
                                <Route
                                    path="/recoverPassword"
                                    element={<FormRecoverPassword authData={authData} />}
                                />
                            </Routes>
                        </Paper>
                    </Grid>
                    <Grid size={{ xs: 0, md: 2 }} />
                </>
            )}

            {isInstallable && (
                <Grid 
                    sx={{
                        position: 'fixed',
                        bottom: { xs: 16, sm: 24 },
                        right: { xs: 16, sm: 24 },
                        zIndex: 1000,
                    }}
                >
                    <p
                        onClick={handleInstallClick}
                        style={{
                            margin: 0,
                            color: '#1976d2',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            fontSize: '0.9rem',
                            fontWeight: 500,
                        }}
                    >
                        Descargar la app
                    </p>
                </Grid>
            )}
        </Grid>
    );
};